import { Change, ChangeType, Element } from '@ritabygglov/core';
import { Command } from './Command';

export class CreateCommand implements Command {
  constructor(
    private elements: Element[],
    private userId: string
  ) {}

  isEphemeral = false;

  execute(): Change[] {
    return this.elements.map((element) => ({
      createdAt: new Date().toISOString(),
      elementType: element.type,
      object: {
        ...element,
        userVersion: {
          userId: this.userId,
          version: 1,
        },
      },
      changeType: ChangeType.Create,
      ephemeral: false,
    }));
  }

  undo(): Change[] {
    return this.elements.map((element) => ({
      createdAt: new Date().toISOString(),
      elementType: element.type,
      object: {
        ...element,
      },
      changeType: ChangeType.Delete,
      ephemeral: false,
    }));
  }
}
